<template>
    <div>
        <input v-model.trim="search" ref="search" type="text" :placeholder="$t('purchaseOrder.searchProductList')"
            class="form-control" />
        <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded">
            <ts-loading-banner :loading="loading">
                <div class="max-h">
                    <table class="ts-w-full">
                        <thead>
                            <tr>
                                <th style="width: 13%;">
                                    {{ $t('serviceQuotation.barcode') }}
                                </th>
                                <th style="width: 24%;">
                                    {{ $t('serviceQuotation.productName') }}
                                </th>
                                <th style="width: 13%;">
                                    {{ $t('serviceQuotation.uom') }}
                                </th>
                                <th style="width: 13%;">
                                    {{ $t('serviceQuotation.qty') }}
                                </th>
                                <th style="width: 20%;">
                                    {{ $t('serviceQuotation.unitPrice') }}
                                </th>
                                <th style="width: 4%;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(product, index) in products" :key="index">
                                <td>{{ product.barcode }}</td>
                                <td>{{ product.product_name_en }}</td>
                                <td>
                                    <a-select v-model="product.uom_id" :options="getUom(product.uom_cat_id)"
                                        option-filter-prop="children" class="ts-w-full" placeholder="Select"
                                        @change="onUomChange(product)"></a-select>
                                </td>
                                <td>
                                    <input type="number" class="form-control ts-text-center"
                                        v-model.number="product.qty" />
                                </td>
                                <td class="ts-text-right">
                                    <ts-currency-input v-model="product.unit_price" class="form-control ts-text-right"
                                        style="min-width: 120px" :currency="'$'" :precision="2" />
                                </td>
                                <td class="ts-text-center ts-cursor-pointer">
                                    <a href="#" class="ts-text-blue-500" @click.prevent="addItem(product)">
                                        <i class="fa fa-plus"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ts-loading-banner>
        </div>
        <small>
            <i>{{ $t('serviceQuotation.clickToAddProduct') }}</i>
        </small>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'productList',
    props: ['value'],
    data() {
        return {
            loading: false,
            search: '',
            model: {}
        }
    },
    created() {
        this.model = this.value
    },
    computed: {
        ...mapState('customerService/serviceQuotation', ['formViewDatas']),
        products() {
            if (this.formViewDatas['products']) {
                return this.formViewDatas['products']
                    .filter(
                        ei =>
                            this.search
                                .split(' ')
                                .every(s =>
                                    ei.barcode.toLowerCase().includes(s.toLowerCase())
                                ) ||
                            this.search
                                .split(' ')
                                .every(s =>
                                    ei.product_name_en.toLowerCase().includes(s.toLowerCase())
                                )
                    )
                    .slice(0, 20)
            }
            return []
        },
        uom() {
            if (this.formViewDatas['uom']) {
                return this.formViewDatas['uom'].map(el => ({
                    value: el.uom_id,
                    label: el.uom_name_en,
                    uom_cat_id: el.uom_cat_id,
                    is_default: el.is_default,
                    stockout_quantity: el.stockout_quantity
                }))
            }
            return []
        },
        systemSetting() {
            if (this.formViewDatas['systemSetting']) {
                return this.formViewDatas['systemSetting']
            }
            return null
        },
    },
    methods: {
        getUom(uom_cat_id) {
            return this.uom.filter(el => el.uom_cat_id == uom_cat_id)
        },
        onUomChange(product) {
            const price = product.sale_code.find(el => el.uom_id == product.uom_id)
            product.unit_price = price ? price.unit_price : 0
            product.input_currency_id = product.currency_id
        },
        addItem(product) {

            let row = {
                repair_product_id: null,
                repair_product_detail_id: null,
                main_product_id: null,
                product_id: product.product_id,
                serial_no: null,
                quantity: product.qty ? product.qty : 1,
                uom_id: product.uom_id,
                currency_id: product.currency_id,
                input_currency_id: product.input_currency_id,
                fx_rate: product.fx_rate,
                fx_rate_ratio: product.fx_rate_ratio,
                unit_price: product.unit_price,
                sub_total: product.unit_price * product.qty,
                discount_type: '%',
                discount_rate: 0,
                discount_amount: 0,
                total_after_discount: product.unit_price * product.qty,
                vat_rate: this.systemSetting.vat_rate,
                vat_amount: (product.unit_price * product.qty * this.systemSetting.vat_rate / 100),
                total: (product.unit_price * product.qty) + (product.unit_price * product.qty * this.systemSetting.vat_rate / 100),
                product_name_en: product.product_name_en,
                barcode: product.barcode,
                uom_cat_id: product.uom_cat_id,
                charge_status: 'charged',
                charge_reason: null,
            }

            this.model.details.push(row)
        }
    },
    watch: {
        validate: function (error) {
            this.errors = new Errors(error.errors)
        }
    }
}
</script>

<style scoped>
.max-h {
    min-height: 60vh;
    max-height: 60vh;
    overflow-y: scroll;
}

.form-control {
    height: 32px;
}

table {
    width: 100%;
}

table thead tr {
    border-width: 1px;
    z-index: 3;
    position: sticky;
    top: 0;
    /* Don't forget this, required for the stickiness */
}

table thead tr th {
    white-space: nowrap;
    background-color: #edf2f7;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

table tbody tr {
    cursor: pointer;
    border-width: 1px;
}

table tbody tr:hover {
    background-color: #e2e8f0;
}

table tbody tr td {
    white-space: nowrap;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border-right-width: 1px;
}
</style>
